const locale = {
	DETAILS_THUMBNAIL_SECTION: 'Immagine copertina',
	DETAILS_THUMBNAIL_SUBHEADER: "Visualizza e modifica l'immagine di copertina",

	DETAILS_COMMUNICATIONS_HEADER_BUTTON_SEND_REMINDER: 'Invia mail reminder',

	// #region Communications fields
	DETAILS_COMMUNICATIONS_FIELD_TITLE: 'Titolo',
	DETAILS_COMMUNICATIONS_FIELD_DATE_FROM: 'Data pubblicazione',
	DETAILS_COMMUNICATIONS_FIELD_DATE_TO: 'Data scadenza',
	DETAILS_COMMUNICATIONS_FIELD_IMAGE: 'Immagine',
	DETAILS_COMMUNICATIONS_FIELD_ACTIVE: 'Attiva',
	DETAILS_COMMUNICATIONS_FIELD_READNOTIFICATION: 'Richiedi conferma di lettura',
	DETAILS_COMMUNICATIONS_FIELD_TAGS: 'Tag',
	DETAILS_COMMUNICATIONS_FIELD_WARNING: 'Warning',
	DETAILS_COMMUNICATIONS_FIELD_BLOCKED: 'Bloccato',
	// #endregion

	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_COMMUNICATION: 'Comunicazione',
	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_USER: 'Utente',
	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_READ: 'Conferma di lettura',
	DETAILS_COMMUNICATIONS_READ_RECEIPTS_FIELD_DATE: 'Data lettura',

	DETAILS_HEADER_BUTTON_COMMUNICATIONS_DOCUMENTS_SETTINGS: 'Configurazione documenti',

	// #region Communication misc fields (dialog, cards)
	TAB_ATTACHMENTS: 'File allegati',
	TAB_READ_RECEIPTS: 'Conferme lettura',
	TAB_READ_RECEIPTS_ALERT_TITLE: 'Conferme di lettura non attivate',
	TAB_READ_RECEIPTS_ALERT_DESCRIPTION:
		'Per tracciare le conferme di lettura abilita l\'opzione "Richiedi conferma di lettura" nei dettagli.',

	COMMUNICATIONS_REMINDER_DIALOG_TITLE_CONFIRM: 'Sei sicuro di voler inviare un reminder?',

	DIALOG_READ_RECEIPTS_TITLE: 'Conferma di lettura',
	DIALOG_READ_NOTIFICATION_MESSAGE_CONTENT:
		'È richiesto l\'invio della conferma di lettura per la comunicazione "{coms_title}". Sei sicuro di aver finito?',
	DIALOG_COMMUNICATION_CONTACT_TEXT: 'CONTATTA',
	COMMUNICATION_CARD_OPEN: 'APRI'
	// #endregion
};

export default locale;
